import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {environment} from "../../../../environments/environment";
import {PageQueryInterface} from "../../../_models/page.interface";

@Injectable({
    providedIn: 'root',
})
export class AssociationService {
    private readonly ASSOC_API: string;

    constructor(private http: HttpClient) {
        this.ASSOC_API = `${environment.apiUrl}/new-admin/new-provider`;
    }

    async getAll(pageQuery: PageQueryInterface): Promise<any> {
        return await this.http.post(this.ASSOC_API + `/all`, pageQuery).toPromise();
    }

    async getAllNoPaging(): Promise<any> {
        return await this.http.get(this.ASSOC_API + `/list`, {}).toPromise();
    }

    async getActivitiesByProviderId(pageQuery: PageQueryInterface, providerId: number): Promise<any> {
        return await this.http.post(this.ASSOC_API + `/all-activities/${providerId}`, pageQuery).toPromise();
    }

    async getById(associationId: number): Promise<any> {
        return await this.http.get(this.ASSOC_API + `/get-one/${associationId}`).toPromise();
    }

    async deleteById(associationId: number): Promise<any> {
        return await this.http.delete(this.ASSOC_API + `/get-one/${associationId}`).toPromise();
    }

    async save(payload: any): Promise<any> {
        return await this.http.post(this.ASSOC_API + `/save`, payload).toPromise();
    }

    async update(payload: any): Promise<any> {
        return await this.http.put(this.ASSOC_API + `/edit`, payload).toPromise();
    }

    async delete(associationId: number): Promise<any> {
        return await this.http.post(this.ASSOC_API + `/delete/${associationId}`, {}).toPromise();
    }

    async getByActivityId(providerId: number, providerActivityId: number): Promise<any> {
        return await this.http.get(this.ASSOC_API + `/get-one/${providerId}/activities/${providerActivityId}`).toPromise();
    }

    async getActivitiesByProviderIdNoPaging(providerId: number): Promise<any> {
        return await this.http.get(this.ASSOC_API + `/list-activities/${providerId}`).toPromise();
    }

    async saveActivity(payload: any, providerId: number): Promise<any> {
        return await this.http.post(this.ASSOC_API + `/get-one/${providerId}/activities`, payload).toPromise();
    }

    async updateActivity(payload: any, providerId: number, providerActivityId: number): Promise<any> {
        return await this.http.put(this.ASSOC_API + `/get-one/${providerId}/activities/${providerActivityId}`, payload).toPromise();
    }

    async deleteActivity(providerId: number, providerActivityId: number): Promise<any> {
        return await this.http.delete(this.ASSOC_API + `/get-one/${providerId}/activities/${providerActivityId}`).toPromise();
    }

    async getCertificationsByProviderId(pageQuery: PageQueryInterface, providerId: number): Promise<any> {
        return await this.http.post(this.ASSOC_API + `/all-certifications/${providerId}`, pageQuery).toPromise();
    }
}
